import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useCreditUsageSubscription } from 'hooks/useCreditUsageSubscription'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'

export const CreditUsageListener = observer(() => {
  const workspaceId = useCurrentWorkspaceId()
  const creditUsageStore = useRootStore().creditUsageStore

  useEffect(() => {
    if (creditUsageStore.initialized) {
      creditUsageStore.refetch(workspaceId)
    } else {
      creditUsageStore.fetch(workspaceId)
    }
  }, [creditUsageStore, workspaceId])

  useCreditUsageSubscription({
    workspaceId,
    onUpdate: creditUsageStore.setCreditUsage,
  })

  return null // This component doesn't render anything
})
